'use strict';

const React = require('react');
const { HeroTeaserArea, MinorTeaserArea } = require('../Teaser');
const TopTeasers = ({hero, topEditorials}) => {
	return (
		<section className="svtse_section">
			<div className="svtse_top-teasers">
				<h1 className="svtse_a11y-hidden">Programtips från SVT</h1>
				<HeroTeaserArea model={hero}/>
				<MinorTeaserArea model={topEditorials}/>
			</div>
		</section>
	);
};

module.exports = TopTeasers;



/** WEBPACK FOOTER **
 ** ./app/components/FirstpageHandler/TopTeasers.js
 **/